import { Component, OnInit } from '@angular/core';
import { service_methods6 } from '../admin/service_methods6';
import { RouterModule, Routes } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  arr_submenus=[]
  constructor(private obj:service_methods6 ,private router: Router) { }

  ngOnInit(): void {
    this.bindsubmenus();
  }

  async bindsubmenus()
  {
 
     await this.obj._commonget("menu_adminpanelmenu_parentmenu").then((data)=>{
    this.arr_submenus=data;
   
    })
  }
}
